import { SubcategoryDetailProps } from "../constants/settingsStructure";
import LegacySettingsRedirect from "../components/LegacySettingsRedirect";

const BoardSettingsDetail = ({ subcategory, categoryId }: SubcategoryDetailProps) => {
  return (
    <LegacySettingsRedirect
      title={subcategory.label}
      description="Configure board-specific settings and preferences."
      categoryId={categoryId}
    />
  );
};

export default BoardSettingsDetail;
